import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $isLeader: boolean }>`
	display: grid;
	grid-template-columns: 1fr 90px auto;
	gap: 20px;
	align-items: center;
	width: 100%;
	height: 60px;
	padding: 0 15px 0 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledNameContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;

		span {
			font-weight: 400;
			opacity: 0.25;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 30px 30px;
	gap: 10px;
`;

export { StyledButtonsContainer, StyledContainer, StyledNameContainer };
